import { clearState, setLoading } from 'src/contexts/utils';
import { IServiceClientInitialContext } from '../types';
import { DEFAULT_SERVICE_CLIENT_STATE } from './defaultState';

export const DEFAULT_SERVICE_CLIENT_CONTEXT: IServiceClientInitialContext = {
    ...DEFAULT_SERVICE_CLIENT_STATE,
    createServiceClientVehicle: () => Promise.resolve(true),
    updateServiceClientVehicle: () => Promise.resolve(true),
    createServiceClientVehicleServiceHistory: () => Promise.resolve(true),
    deleteServiceClientVehicleServiceHistory: () => Promise.resolve(true),
    createServiceClient: () => Promise.resolve(undefined),
    upsertServiceClientFromSoldLead: () => Promise.resolve(undefined),
    updateServiceClient: () => Promise.resolve(undefined),
    getServiceClientById: () => Promise.resolve(),
    sendTemplateServiceClient: () => Promise.resolve(),
    clearState,
    setLoading,
    searchServiceClientsByFilters: async () => { },
};
